// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { initialize } from 'redux-form'

const clearPathImportValues = sourceForm => (dispatch, getState) => {

  const initialValues = {
    bandId: [],
    contactId: [],
    createUserId: {
      userId: null,
      userName: null,
    },
    pagination:null,
    projectName: '',
  }

  dispatch(initialize(sourceForm, initialValues))
}

export default clearPathImportValues
